import React, { useCallback } from 'react'

import { useSelectedTrial } from 'src/features/auth/context'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { DeleteModal } from './delete-modal'
import { submitDelete } from '../../../../../../../entities/template-folder/request'
import { useRequestState } from '../../../../../../../server/use-request-state'
import { useTemplateEntities } from '../../../template-entities-context'

type Props = {
  onClose: () => void
  templateFolderUid: string
}

export const DeleteModalContainer: React.FC<Props> = props => {
  const { getTemplateFolder } = useTemplateEntities()
  const templateFolder = getTemplateFolder(props.templateFolderUid)
  const { request, requesting } = useDeleteTemplateFolder(
    props.templateFolderUid,
  )
  const onSubmit = useCallback(async () => {
    await request()
    props.onClose()
  }, [props, request])

  if (!templateFolder) return null

  return (
    <DeleteModal
      templateFolderName={templateFolder.name}
      onClose={props.onClose}
      onSubmit={onSubmit}
      requesting={requesting}
    />
  )
}

const useDeleteTemplateFolder = (templateFolderUid: string) => {
  const { selectedTrial } = useSelectedTrial()
  const trialUid = selectedTrial.uid
  const { requesting, errorMessage, requestDone, requestStarted } =
    useRequestState()
  const { deleteTemplateFolder } = useTemplateEntities()

  const toast = useMirohaToast()

  const request = useCallback(async () => {
    try {
      requestStarted()
      await submitDelete({ trialUid, templateFolderUid })
      deleteTemplateFolder(templateFolderUid)
      toast({
        status: 'success',
        title: 'フォルダを削除しました',
      })
      requestDone()
    } catch (error) {
      toast({
        status: 'error',
        title: error.message,
      })
      requestDone()
    }
  }, [
    deleteTemplateFolder,
    requestDone,
    requestStarted,
    trialUid,
    templateFolderUid,
    toast,
  ])

  return { request, requesting, errorMessage }
}
